/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateMillingElementDto } from '../../models/create-milling-element-dto';
import { MillingElement } from '../../models/milling-element';

export interface CreateOneBaseMgmtMillingElementControllerMillingElement$Params {
      body: CreateMillingElementDto
}

export function createOneBaseMgmtMillingElementControllerMillingElement(http: HttpClient, rootUrl: string, params: CreateOneBaseMgmtMillingElementControllerMillingElement$Params, context?: HttpContext): Observable<StrictHttpResponse<MillingElement>> {
  const rb = new RequestBuilder(rootUrl, createOneBaseMgmtMillingElementControllerMillingElement.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MillingElement>;
    })
  );
}

createOneBaseMgmtMillingElementControllerMillingElement.PATH = '/api/mgmt/milling-element';
